import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const EVERYWHERE = 'everywhere';
export const MULTICITY = 'Multicity';

export const SEARCH_PLACE_TYPES = {
  EVERYWHERE: 'Everywhere',
  NATION: 'Nation',
  CITY: 'City',
  AIRPORT: 'Airport',
  MULTICITY: 'Multicity',
  FIRST_LEVEL_NATION: 'FirstLevelNationAdministrativeDivision',
} as const;

export const PLACE_TYPES = {
  EVERYWHERE: 'EVERYWHERE',
  COUNTRY: 'COUNTRY',
  COUNTRY_ORIGIN: 'COUNTRY_ORIGIN',
} as const;

export type PlaceSearchType = Values<typeof PLACE_TYPES>;

export const VERTICAL_PLACE_TYPES = {
  EVERYWHERE: 'EverywhereDestination',
  COUNTRY: 'CountryDestination',
  COUNTRY_ORIGIN: 'CountryOrigin',
} as const;

const placeToVerticalMap = {
  [PLACE_TYPES.COUNTRY]: VERTICAL_PLACE_TYPES.COUNTRY,
  [PLACE_TYPES.EVERYWHERE]: VERTICAL_PLACE_TYPES.EVERYWHERE,
  [PLACE_TYPES.COUNTRY_ORIGIN]: VERTICAL_PLACE_TYPES.COUNTRY_ORIGIN,
};

export const getVerticalFromPlaceType = (placeSearchType: PlaceSearchType | null) =>
  placeSearchType && placeToVerticalMap[placeSearchType];

// target fields related to place in CE response: Record<PLACE_TYPE, PLACE_FIELD>
export const PLACE_FIELD_NAME = {
  [PLACE_TYPES.EVERYWHERE]: 'everywhereDestination',
  [PLACE_TYPES.COUNTRY]: 'countryDestination',
  [PLACE_TYPES.COUNTRY_ORIGIN]: 'countryOrigin',
} as const;

// Record<PLACE_FIELD, PLACE_TYPE>
export const PLACE_FIELD_TYPE = {
  [PLACE_FIELD_NAME.EVERYWHERE]: PLACE_TYPES.EVERYWHERE,
  [PLACE_FIELD_NAME.COUNTRY]: PLACE_TYPES.COUNTRY,
  [PLACE_FIELD_NAME.COUNTRY_ORIGIN]: PLACE_TYPES.COUNTRY_ORIGIN,
};

// An array consisting of PLACE_FIELD
export const PLACE_FIELD_NAME_LIST = Object.values(PLACE_FIELD_NAME);

export const PLACE_RESULT_TYPE = {
  LOCATION: 'LOCATION',
  ADVERT: 'ADVERT',
} as const;

export const FILTER_PILLS = {
  DIRECT: 'DIRECT',
} as const;
